import React, { useState } from "react";
import WelcomeScreenTitleBar from "../../components/WelcomeScreen/WelcomeScreenTitleBar";
import SessionIdModal from "../../components/Collab/SessionIdModal";
import { LoginModal } from "../../components/Auth/LoginModal";
import { RegisterModal } from "../../components/Auth/RegisterModal";
import { useCollab } from "../../contexts/CollabContext";
import { useAuth } from "../../contexts/AuthContext";
import { useProject } from "../../contexts/ProjectContext";
import { getRecentProjects, ProjectInfo } from "../../utils/localStorageUtils";
import { useGlobalContext } from "../../contexts/GlobalContext";

const WelcomeContainer: React.FC = () => {

  const [showAll, setShowAll] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  
  // Check if running in Electron
  const isElectron = typeof window !== 'undefined' && window.electron !== undefined;
  
  const collab = useCollab();
  const { isAuthenticated, user } = useAuth();
  const { openProject, openRecentProject } = useProject();

  // Her render'da localStorage'dan oku
  const recentProjects: ProjectInfo[] = getRecentProjects();
  const visibleProjects = showAll ? recentProjects : recentProjects.slice(0, 3);

  const handleJoinSessionClick = () => {
    if (!isAuthenticated) {
      // Not authenticated, show login modal
      setShowLoginModal(true);
    } else {
      // Authenticated, show session modal
      setShowSessionModal(true);
    }
  };

  const handleLoginSuccess = () => {
    // After successful login, open session modal
    setShowSessionModal(true);
  };

  const handleJoinSessionSubmit = async (
    sessionId: string
  ) => {
    const success = await collab.joinSession(sessionId);
    if (success) {
      setShowSessionModal(false);
    }
  };

  const handleSwitchToRegister = () => {
    setShowLoginModal(false);
    setShowRegisterModal(true);
  };

  const handleSwitchToLogin = () => {
    setShowRegisterModal(false);
    setShowLoginModal(true);
  };

  return (
    <div
      className="welcome-screen"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "#181A20",
        color: "#fff",
        position: "relative",
        fontFamily: `'Segoe UI', 'Arial', 'Liberation Sans', 'DejaVu Sans', 'sans-serif'`,
      }}
    >
      <WelcomeScreenTitleBar 
        onLoginClick={() => setShowLoginModal(true)}
        onRegisterClick={() => setShowRegisterModal(true)}
      />
      <div
        style={{ marginBottom: 32, textAlign: "center", userSelect: "none" }}
      >
        <img
          src="/icon.png"
          alt="Logo"
          style={{
            width: 64,
            height: 64,
            marginBottom: 16,
            pointerEvents: "none",
          }}
        />
        <h1 style={{ margin: 0 }}>Collab</h1>
        <span style={{ color: "#8a8f98" }}>Let's code together.</span>
      </div>
      <div style={{ display: "flex", gap: 16, marginBottom: 32 }}>
        {isElectron && (
          <button
            onClick={openProject}
            style={{
              padding: "12px 24px",
              borderRadius: 6,
              border: "none",
              background: "#23262F",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Open project
          </button>
        )}
        {/* <button disabled style={{ padding: '12px 24px', borderRadius: 6, border: 'none', background: '#23262F', color: '#8a8f98', fontWeight: 600 }}>Clone repo</button>
        <button disabled style={{ padding: '12px 24px', borderRadius: 6, border: 'none', background: '#23262F', color: '#8a8f98', fontWeight: 600 }}>Connect via SSH</button> */}
        <button
          onClick={handleJoinSessionClick}
          style={{
            padding: "12px 24px",
            borderRadius: 6,
            border: "none",
            background: "#23262F",
            color: "#fff",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Join Session
        </button>
      </div>
      
      {showLoginModal && (
        <LoginModal
          isOpen={showLoginModal}
          onClose={() => setShowLoginModal(false)}
          onSwitchToRegister={handleSwitchToRegister}
          onSuccess={handleLoginSuccess}
        />
      )}
      
      {showRegisterModal && (
        <RegisterModal
          isOpen={showRegisterModal}
          onClose={() => setShowRegisterModal(false)}
          onSwitchToLogin={handleSwitchToLogin}
          onSuccess={handleLoginSuccess}
        />
      )}
      
      {showSessionModal && (
        <SessionIdModal
          onSubmit={handleJoinSessionSubmit}
          onClose={() => setShowSessionModal(false)}
        />
      )}
      {isElectron && (
        <div style={{ width: 340 }}>
          <h4 style={{ margin: "0 0 8px 0", color: "#8a8f98" }}>
            Recent projects
          </h4>
          <div
            style={{
              borderRadius: 10,
              background: "#181A20",
              border: "1px solid #23262F",
              marginBottom: 8,
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              transition: "all 0.2s",
              padding: 0,
              maxHeight: showAll ? 320 : "none",
              overflowY: showAll ? "auto" : "visible",
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none", // IE/Edge
            }}
            className={showAll ? "hide-scrollbar" : ""}
          >
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {visibleProjects.map((project) => (
                <li
                  key={project.path}
                  onClick={() => openRecentProject(project.path)}
                  style={{
                    marginBottom: 6,
                    padding: "10px 14px",
                    borderRadius: 7,
                    background: "#20232a",
                    color: "#fff",
                    cursor: "pointer",
                    transition: "background 0.2s",
                    fontWeight: 500,
                    fontSize: 14,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    border: "1px solid #23262F",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    position: "relative",
                    zIndex: 1,
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.background = "#23262F")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.background = "#20232a")
                  }
                >
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: 14,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: 260,
                    }}
                  >
                    {project.name}
                  </span>
                  <span
                    style={{
                      fontSize: 11,
                      color: "#8a8f98",
                      marginTop: 2,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: 260,
                    }}
                  >
                    {project.path}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          {recentProjects.length > 3 && (
            <div style={{ textAlign: "center", marginTop: 8 }}>
              <button
                onClick={() => setShowAll((v) => !v)}
                style={{
                  background: showAll ? "#23262F" : "none",
                  border: "none",
                  color: "#8a8f98",
                  cursor: "pointer",
                  fontSize: 13,
                  textDecoration: "underline",
                  borderRadius: 6,
                  padding: "6px 12px",
                  transition: "background 0.2s",
                }}
              >
                {showAll ? "Daha az göster" : "Hepsini göster"}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default WelcomeContainer;
